/**
 * Environment configuration helper
 * Handles environment variables in both Vite and Jest/Node environments
 */

type ImportMetaEnv = {
  VITE_API_BASE_URL?: string;
  VITE_KINDE_DOMAIN?: string;
  VITE_KINDE_CLIENT_ID?: string;
  VITE_KINDE_REDIRECT_URI?: string;
  VITE_KINDE_LOGOUT_URI?: string;
  VITE_GOOGLE_MAPS_API_KEY?: string;
};

/**
 * Gets environment variable value
 * Works in both Vite (import.meta.env) and Jest (global.import.meta.env) environments
 */
const getEnvVar = (key: keyof ImportMetaEnv): string | undefined => {
  // Check if we're in a test environment with mocked import.meta
  if (typeof global !== 'undefined' && (global as any).import?.meta?.env) {
    return (global as any).import.meta.env[key];
  }
  
  // Check if import.meta is available (Vite environment)
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key];
  }
  
  return undefined;
};

export const env = {
  API_BASE_URL: getEnvVar('VITE_API_BASE_URL') || 'http://localhost:3001/api/v1',
  KINDE_DOMAIN: getEnvVar('VITE_KINDE_DOMAIN') || '',
  KINDE_CLIENT_ID: getEnvVar('VITE_KINDE_CLIENT_ID') || '',
  KINDE_REDIRECT_URI: getEnvVar('VITE_KINDE_REDIRECT_URI') || 'http://localhost:3000',
  KINDE_LOGOUT_URI: getEnvVar('VITE_KINDE_LOGOUT_URI') || 'http://localhost:3000',
  GOOGLE_MAPS_API_KEY: getEnvVar('VITE_GOOGLE_MAPS_API_KEY') || '',
};


